module.exports = __webpack_public_path__ + "img/review-4.a5c772d9.png";